import { RESET_STATE } from '../../shared/actions/common-actions';
import {
  FILE_DELETE,
  FILE_FETCH,
  FILE_LOADING,
  FILE_SUBMIT,
  FILE_SUBMIT_NEW_DOCUMENTS,
  FILE_SUBMIT_NOTIFICATIONS,
  FILE_UPDATE,
  FILE_WITHDRAW,
} from './actions';
import { FILE_SUBMIT_EUGBR } from '../components/eugbr/components/actions/action';

const initialState = {
  isLoading: false,
  entryFormGeneralInformation: {
    issueName: '',
    languages: [],
    requestDetails: {},
    relatedDocumentId: '',
  },
  legalEntities: [],
  entitledPersons: [],
  entryFormLegislation: {
    applicableParagraphs: [],
    legalGrounds: [],
    disclosureRegimes: [],
    disclosureRegimesAmended: [],
    financialAnnexesCategories: [],
  },
  entryFormReview: {
    requestedApprovalDate: '',
    additionalInformation: '',
  },
  parent: {},
  securities: [],
  notifications: [],
  readerUsername: '',
  readerLastname: '',
};

function reducerEntryForm(state = initialState, action: any) {
  switch (action.type) {
    case FILE_LOADING:
    case FILE_UPDATE:
    case FILE_FETCH:
    case FILE_SUBMIT:
    case FILE_SUBMIT_EUGBR:
    case FILE_SUBMIT_NOTIFICATIONS:
    case FILE_SUBMIT_NEW_DOCUMENTS:
    case FILE_DELETE:
    case FILE_WITHDRAW:
    case RESET_STATE:
      return { ...initialState, ...action.payload };

    default:
      return state;
  }
}
export default reducerEntryForm;
